module.exports = __webpack_public_path__ + "static/media/user.8635ffe2.png";